// extracted by mini-css-extract-plugin
export default {"container":"CareRecipientRegistrationButton_container__ef-mm"};